import { render, staticRenderFns } from "./PasswordRecoveryConfirm.vue?vue&type=template&id=ae396a5e&"
import script from "./PasswordRecoveryConfirm.vue?vue&type=script&lang=ts&"
export * from "./PasswordRecoveryConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports